import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';
import { TASK_AUDIENCE_OPTIONS, type TaskAudience } from './taskAudience';

interface TaskAudienceFieldProps {
  value: TaskAudience;
  onChange: (value: TaskAudience) => void;
}

export function TaskAudienceField({ value, onChange }: TaskAudienceFieldProps) {
  const { t } = useTranslation('workorders');

  return (
    <TextField
      select
      label={t('tasks.audience')}
      helperText={t('tasks.audienceHelper')}
      value={value}
      onChange={(e) => onChange(e.target.value as TaskAudience)}
      fullWidth
    >
      {TASK_AUDIENCE_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {t(option.labelKey)}
        </MenuItem>
      ))}
    </TextField>
  );
}
